import Glide from "@glidejs/glide";

function setCarouselHeight() {
    const slides = document.querySelectorAll(".glide .glide__slide");
    let maxTotalHeight = 0;
    let imagesLoaded = 0;
    const totalSlides = slides.length;

    slides.forEach((slide) => {
        const img = slide.querySelector("img");
        if (img.complete && img.naturalWidth) {
            processSlide(slide, img);
        } else {
            img.addEventListener("load", () => {
                processSlide(slide, img);
            });
        }
    });

    function processSlide(slide, img) {
        const aspectRatio = img.naturalWidth / img.naturalHeight;
        const slideWidth = slide.offsetWidth;
        const imgContainerHeight = slideWidth / aspectRatio;
        const caption = slide.querySelector(".slide-caption");
        const captionHeight = caption ? caption.offsetHeight : 0;
        const slideTotalHeight = imgContainerHeight + captionHeight;

        maxTotalHeight = Math.max(maxTotalHeight, slideTotalHeight);
        
        imagesLoaded++;
        if (imagesLoaded === totalSlides) {
            applyHeight();
        }
    }

    function applyHeight() {
        slides.forEach((slide) => {
            slide.style.minHeight = `${maxTotalHeight}px`;
            const imgContainer = slide.querySelector(".slide-image-container");
            if (imgContainer) {
                const caption = slide.querySelector(".slide-caption");
                imgContainer.style.height = `${maxTotalHeight - (caption?.offsetHeight || 0)}px`;
            }
        });
    }
}

export function initializeGlide() {
    const glideElement = document.querySelector(".glide");
    if (!glideElement) return;

    const glide = new Glide(".glide", {
        type: "carousel",
        perView: 3,
        gap: 10,
        breakpoints: {
            768: {
                perView: 2,
                gap: 5,
            },
        },
    });

    glide.on("mount.after", setCarouselHeight);
    window.addEventListener("resize", setCarouselHeight);
    glide.mount();
}